import {
  Backdrop,
  Button,
  Container,
  Select,
  InputLabel,
  Fade,
  FormControl,
  Grid,
  ListItemText,
  // Modal,
  Paper,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  MenuItem,
} from "@material-ui/core";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  // Table,
  Row,
  Col,
  UncontrolledAlert,
  // Pagination,
  // PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";
import Modal from "react-awesome-modal";
import { Pagination, PaginationItem } from "@material-ui/lab";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { Component } from "react";
import Constants from "../Variables/Constants";
import init from "../../helpers/WindowToken";
import "../../App.css";
import {
  InsertEmoticon,
  LowPriority,
  PlaylistAddOutlined,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core";
const classes = makeStyles();

export default class UserList extends Component {
  state = {
    getAllUsers: [],
    // page: 1,
    search: "",
    sort: "",
    // limit: 10,
    message: "",

    // MODAL STATES

    notifyStatus: false,
    notifyDelete: false,
    childModel: false,
    visible: false,
    delLoading: false,
    rowId: 0,

    profileData: [],
    // role:"agent",

    // PAGINATION STATES

    delete_type: "",
    // temporary:'temporary',

    limit: 20,
    page: 1,
    nextPage: false,
    prevPage: false,
    total: 0,
    totalpage: 1,

    // PAGINATION STATES

    // serch list
    query_title: "",
    query_value: "",
    searchQuery: "",
    name: "",
    email: "",
    searchmessage: "",
    searchmess: false,
  };
  componentDidMount() {
    this.getUserList();
  }

  // getUserList = () => {
  //   axios.get(Constants.getUrls.getProfile).then((res) => {
  //     // console.log(res.data.user.role);
  //     // this.setState({
  //     //   profileData: res.data.user,
  //     // });
  //     // console.log(this.state.profileData.role);
  //   });
  // };

  getUserList = () => {
    // if (init() === "success") {
    axios
      .get(
        Constants.getUrls.getUserList +
          `?limit=${this.state.limit}` +
          `&page=${this.state.page}`
      )
      .then((resp) => {
        console.log(resp);
        this.setState(
          {
            getAllUsers: resp.data.data,
            limit: resp.data.pagination?.limit,
            nextPage: resp.data.pagination?.nextpage,
            page: resp.data.pagination?.page,
            prevPage: resp.data.pagination?.prevpage,
            totalpage: resp.data.pagination?.totalpage,
            total: resp.data.pagination?.total,

            empty: resp.data.message === "No Search Found!" ? true : false,
          },

          () => {
            // console.log(this.state.limit);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
    // }
  };

  // handleRows start
  handleRows = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (init() === "success") {
          axios
            .get(
              Constants.getUrls.getUserList +
                `?user_type=normal` +
                `&limit=${this.state.limit}` +
                `&page=${this.state.page}`
            )
            .then((resp) => {
              console.log(resp);
              this.setState({
                getAllUsers: resp.data.data,
                limit: resp.data.pagination.limit,
                nextPage: resp.data.pagination.nextpage,
                page: resp.data.pagination.page,
                prevPage: resp.data.pagination.prevpage,
                totalpage: resp.data.pagination.totalpage,
                total: resp.data.pagination.total,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    );
  };

  // handleRows end

  // PAGINATION BUTTONS
  handleNext = (e) => {
    // console.log(Constants.getUrls.getUserList +
    //   `?limit=${this.state.limit}` +
    //   `&page=${this.state.page + 1}`);
    if (init() === "success") {
      axios
        .get(
          Constants.getUrls.getUserList +
            `?user_type=normal` +
            `&limit=${this.state.limit}` +
            `&page=${this.state.page + 1}`
        )
        .then((resp) => {
          console.log(resp);
          this.setState({
            getAllUsers: resp.data.data,
            limit: resp.data.pagination.limit,
            nextPage: resp.data.pagination.nextpage,
            page: resp.data.pagination.page,
            prevPage: resp.data.pagination.prevpage,
            totalpage: resp.data.pagination.totalpage,
            total: resp.data.pagination.total,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handlePrev = () => {
    if (init() === "success") {
      axios
        .get(
          Constants.getUrls.getUserList +
            `?user_type=normal` +
            `&limit=${this.state.limit}` +
            `&page=${this.state.page - 1}`
        )
        // axios.get('http://localhost:8084/getContests')
        .then((resp) => {
          console.log(resp);
          this.setState({
            getAllUsers: resp.data.data,
            limit: resp.data.pagination.limit,
            nextPage: resp.data.pagination.nextpage,
            page: resp.data.pagination.page,
            prevPage: resp.data.pagination.prevpage,

            totalpage: resp.data.pagination.totalpage,
            total: resp.data.pagination.total,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleChange = (event, value) => {
    this.setState(
      {
        page: value,
      },
      () => {
        this.getUserList();
      }
    );
  };

  handleModalDel = (user) => {
    // alert: false
    this.setState({
      rowId: user._id,
      delete_type: this.state.delete_type,
      visible: true,
      childModel: false,
    });
  };

  handleDeleteM = (type) => {
    this.setState({
      delLoading: true,
    });
    let payload = {
      // _id: this.state.rowId,
      delete_type: this.state.delete_type,
    };
    console.log(this.state.delete_type);

    if (init() == "success") {
      this.setState({ delLoading: true });
      axios
        .put(Constants.deleteUrls.deleteUser + this.state.rowId)
        .then((res) => {
          console.log(res);
          this.setState({
            notifyDelete: true,
            delLoading: false,
            delMsg: res.data.message,
            childModel: true,
            visible: true,
          });
          setTimeout(() => {
            this.setState(
              { notifyDelete: false, visible: false, childModel: false },
              () => {
                this.getUserList();
              }
            );
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // DELETE END

  render() {
    return (
      <Container maxWidth="xl">
        {/* <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={true}
          color={"s"}
          autoHideDuration={6000}
          message={this.state.message}
        ></Snackbar> */}
        <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
          <Grid item xs={6}>
            {/* <Typography variant="h6">title</Typography> */}
            <Typography variant="h5">User List</Typography>
            <br></br>
          </Grid>

          <Grid item xs={6}></Grid>
        </Grid>
        <br></br>
        <Grid item sm={12}>
          <Paper elevation={1}>
            <TableContainer>
              <Table size="small" stickyHeader aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>S. no</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>User Email</TableCell>
                    <TableCell>Mobile Number</TableCell>
                    <TableCell>Address</TableCell>
                    {/* <TableCell>User Type</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Budget</TableCell>
                    <TableCell>Event Date</TableCell> */}
                    {/* <TableCell>Contest Participated</TableCell> */}

                    <TableCell align="right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!this.state.empty ? (
                    this.state.getAllUsers.map((user, i) => (
                      <TableRow key={user._id}>
                        <TableCell>
                          {" "}
                          {Number((this.state.page - 1) * this.state.limit) +
                            Number(i + 1)}{" "}
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {user.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {user.email}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {user.mobile_no}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {user?.address}
                        </TableCell>

                        <TableCell align="right">
                          <Button
                            size={"small"}
                            variant={"outlined"}
                            color="Secondary"
                            onClick={() => {
                              this.handleModalDel(user);
                            }}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell>No Search Found!</TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter></TableFooter>
              </Table>

              {/* PAGINATION TABLE START */}

              <TableRow
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                <div>
                  <p>
                    Showing {this.state.page} to{" "}
                    {Number((this.state.page - 1) * this.state.limit) +
                      this.state.limit}{" "}
                    of {this.state.total} Entries
                  </p>
                </div>

                {/* Rows PerPage START */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <p>Rows Per Page</p>

                  <FormControl
                    className="selectMerchants"
                    style={{ marginRight: "20px", marginTop: "-12px" }}
                  >
                    <InputLabel htmlFor="age-native-simple"></InputLabel>
                    <Select
                      native
                      value={this.state.limit}
                      onChange={this.handleRows}
                      inputProps={{
                        name: "limit",
                        id: "age-native-simple",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="35">35</option>
                      <option value="55">55</option>
                      <option value="75">75</option>
                      <option value="100">100</option>
                    </Select>
                  </FormControl>
                </div>
                {/* Rows PerPage END */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginLeft: "290px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className="mx-5"
                    style={{ margin: "10px" }}
                    disabled={this.state.prevPage === false}
                    onClick={this.handlePrev}
                    // Hidden
                  >
                    Previous
                  </Button>{" "}
                  <Pagination
                    count={this.state.totalpage}
                    shape="rounded"
                    page={this.state.page}
                    onChange={this.handleChange}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-5"
                    disabled={this.state.nextPage === false}
                    style={{ margin: "10px" }}
                    onClick={this.handleNext}
                  >
                    Next
                  </Button>
                </div>
              </TableRow>
              {/* PAGINATION TABLE END */}
            </TableContainer>
          </Paper>
        </Grid>

        {/* MODAL START */}

        <Modal
          visible={this.state.visible}
          width="450"
          height="76"
          effect="fadeInUp"
          onClickAway={() => this.setState({ visible: false })}
        >
          <Row>
            <Col xs={12} sm={12} md={12}>
              <Card>
                {/* <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4>Stacked Form</h4>
                </CardHeader> */}

                <CardBody>
                  {/* style={{ backgroundColor:"gray"}} */}
                  <div className="modal">
                    <Row>
                      <Col xs={12} sm={12} md={4}>
                        <br />

                        <Button
                          className=""
                          variant="contained"
                          color="secondary"
                          value={this.state.permanent}
                          style={{ margin: "20px" }}
                          onClick={() => {
                            this.setState({
                              childModel: true,
                              delete_type: "permanent",
                              visible: true,
                            });
                          }}
                        >
                          Permanent Delete
                        </Button>

                        {this.state.childModel ? (
                          // <CardBody>

                          <div className="modal">
                            <h3 className="changeColor">
                              Are You Sure You Want to Delete It?
                            </h3>
                            {this.state.notifyDelete ? (
                              <Snackbar
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                open={true}
                                color={"s"}
                                autoHideDuration={6000}
                                message=" User Deleted Successfuly!"
                              ></Snackbar>
                            ) : null}
                            <Row>
                              <Col xs={12} sm={12} md={4}>
                                <br />
                                <Button
                                  className=""
                                  variant="contained"
                                  color="secondary"
                                  style={{ margin: "20px" }}
                                  onClick={() => {
                                    this.handleDeleteM(this.state.delete_type);
                                  }}
                                >
                                  {this.state.delLoading
                                    ? "Deleting..."
                                    : "Yes"}
                                </Button>

                                <Button
                                  className=""
                                  variant="contained"
                                  color="primary"
                                  style={{ margin: "20px", marginLeft: "4px" }}
                                  onClick={() => {
                                    this.setState({ visible: false });
                                  }}
                                >
                                  No
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        ) : // </CardBody>

                        null}
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Modal>
        {/* MODAL END */}
      </Container>
    );
  }
}
